import React from 'react';
import { answerRateTone, formatNumber, formatPercent } from '../../utils/format';
import type { AgentStats } from '../../types/voip';
export function MetricStrip({
  stats
}: {
  stats: AgentStats;
}) {
  const items = [{
    label: 'Made',
    value: formatNumber(stats.outbound),
    tone: 'text-ink'
  }, {
    label: 'Answered',
    value: formatNumber(stats.inbound),
    tone: 'text-ink'
  }, {
    label: 'Missed',
    value: formatNumber(stats.missed),
    tone: 'text-danger'
  }, {
    label: 'Answer rate',
    value: formatPercent(stats.answerRate),
    tone: answerRateTone(stats.answerRate)
  }];
  return <dl className="grid w-full grid-cols-4 gap-2" data-id="element-110" data-mp="2uw9xd02ioucu">
      {items.map(i => <div key={i.label} className="min-w-0" data-id="element-111" data-mp="2uu6xlobkbmux">
          <dd className={`text-sm font-bold ${i.tone}`} data-id="element-112" data-mp="2pyhujb0c3ntv">{i.value}</dd>
          <dt className="truncate text-[11px] text-muted" data-id="element-113" data-mp="2lvljc5d4itzy">{i.label}</dt>
        </div>)}
    </dl>;
}